const Footer = () => {
  return (
    <footer className="bg-[#f7f5f0] text-gray-700">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">

          {/* Brand Block */}
          <div className="flex-shrink-0 lg:w-72">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-green-600 rounded-full">
                <i className="ri-leaf-line text-white text-base"></i>
              </div>
              <span className="font-extrabold text-2xl text-gray-900 tracking-tight">시골가는길</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              산지에서 직접 엄선한 신선한 과일을<br />합리적인 가격으로 빠르게 배송해드립니다.
            </p>
            <a
              href="https://open.kakao.com/o/s3bl7ioi"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-kakao-talk-fill text-base"></i>
              카카오톡 주문하기
            </a>
          </div>

          {/* Divider */}
          <div className="hidden lg:block w-px bg-gray-200 self-stretch"></div>

          {/* Info Grid */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Contact */}
            <div>
              <h4 className="text-xs font-bold tracking-widest uppercase text-green-600 mb-4">연락처</h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-green-600 text-xs"></i>
                  </div>
                  <span>010-5176-8253</span>
                </li>
                <li className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0">
                    <i className="ri-time-line text-green-600 text-xs"></i>
                  </div>
                  <span>평일 00:00 ~ 00:00</span>
                </li>
                <li className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-green-600 text-xs"></i>
                  </div>
                  <span>전국 산지 직송</span>
                </li>
              </ul>
            </div>

            {/* Business Info */}
            <div>
              <h4 className="text-xs font-bold tracking-widest uppercase text-green-600 mb-4">사업자 정보</h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-building-2-line text-green-600 text-xs"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">사업자등록번호</p>
                    <p className="font-semibold text-gray-800">250-99-01893</p>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-user-3-line text-green-600 text-xs"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">대표자</p>
                    <p className="font-semibold text-gray-800">김성훈</p>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-sm text-gray-600">
                  <div className="w-7 h-7 flex items-center justify-center bg-green-50 rounded-full flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-green-600 text-xs"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 mb-0.5">이메일</p>
                    <p className="font-semibold text-gray-800">dkcl7070@naver.com</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 py-5">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">© 2026 시골가는길. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-gray-400 hover:text-gray-600 text-xs transition-colors cursor-pointer">개인정보처리방침</a>
            <a href="#" className="text-gray-400 hover:text-gray-600 text-xs transition-colors cursor-pointer">이용약관</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
